import { apiFetch } from './client';
import type { Notification } from '../types/mjai';

export async function getNotifications(unreadOnly = false): Promise<Notification[]> {
  const query = unreadOnly ? '?unread_only=true' : '';
  return apiFetch<Notification[]>(`/notifications${query}`);
}

export async function getUnreadCount(): Promise<{ count: number }> {
  return apiFetch<{ count: number }>('/notifications/unread-count');
}

export async function markRead(notificationId: string): Promise<Notification> {
  return apiFetch<Notification>(`/notifications/${notificationId}/read`, { method: 'PATCH' });
}

export async function markAllRead(): Promise<void> {
  await apiFetch<void>('/notifications/read-all', { method: 'POST' });
}
